// src/AudioSpectrum/effects/spiral.js
import { getHSLColor } from '../colorUtils.js';

export const drawSpiral = (ctx, frequencyData, width, height) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const maxRadius = Math.min(width, height) / 2 - 20;
  
  ctx.clearRect(0, 0, width, height);
  
  const barCount = Math.min(frequencyData.length / 2, 200);
  const spiralTurns = 3;
  
  ctx.beginPath();
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const progress = i / barCount;
    const angle = progress * spiralTurns * Math.PI * 2;
    const baseRadius = progress * maxRadius;
    const radius = baseRadius + (value / 255) * 30;
    
    const x = centerX + Math.cos(angle) * radius;
    const y = centerY + Math.sin(angle) * radius;
    
    if (i === 0) {
      ctx.moveTo(x, y);
    } else {
      ctx.lineTo(x, y);
    }
    
    // 점 그리기
    ctx.fillStyle = getHSLColor(progress * 360, 100, 50);
    ctx.beginPath();
    ctx.arc(x, y, (value / 255) * 3 + 1, 0, Math.PI * 2);
    ctx.fill();
  }
};